import { useState, useCallback } from 'react';

import { ICompsViewerState } from './types';
import { NidSearch } from './modules/NidSearch/NidSearch';
import { CompsMap } from './modules/CompsMap/CompsMap';

const CompsViewerPage = () => {
  const [viewerData, setViewerData] = useState<ICompsViewerState | null>(null);

  const handleLoad = useCallback((data: ICompsViewerState) => setViewerData(data), []);
  const handleReset = useCallback(() => setViewerData(null), []);

  if (viewerData) {
    return <CompsMap data={viewerData} onReset={handleReset} />;
  }

  return <NidSearch onLoad={handleLoad} />;
};

export default CompsViewerPage;
